export * from "./merge.js";
export * from "./all-of-merge.js";
export * from "./patterns.js";
//# sourceMappingURL=index.js.map